import Vue from 'vue';
import UUID from 'vue-uuid';

// @ts-expect-error - UUID does not follow expected types
Vue.use(UUID);
